import Recall from 'lib/pages/Recall'
export default Recall
